import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../../components/base/Dialog/Dialog';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import { Button, Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import RepresentativeDTO from '../../../../dto/RepresentativeDTO';
import AutoAcceptApplicant from '../AutoAcceptApplicant';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import { loadUserList } from '../../../User/actions';
import CustomSelectInputWithHelper from '../../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { getProfileData } from '../../reducer';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import { acceptRepresentative, loadRepresentativeById } from '../../actions';
import { responseLogWithNotification } from '../../../../utils/utils';
import { successNotification } from '../../../Notifications/notificationDecorator';

export function RepresentativeAproveInviteFormModal(props) {
  const {
    onClose = () => {}, onSend = () => {},
  } = props;
  const dto = new RepresentativeDTO();
  const attributes = dto.getAttributesByName();
  const dispatch = useDispatch();
  const {
    representative,
  } = useSelector(getProfileData);

  const {
    control, getValues, setValue,
  } = useForm({
    defaultValues: {
      is_permanent: false,
      ...representative,
    },
  });

  useEffect(() => {
    const date = moment(getValues('created_at'));
    const newDate = date.add(1, 'year');
    setValue('validity_period', newDate);
  }, []);

  const handleRename = item => {
    dispatch(acceptRepresentative(item)).then(() => {
      successNotification('Приглашение приянято', 'Успех');
      onClose();
    }).catch(responseLogWithNotification);
  };

  return (
    <Dialog
      className="uspd-representative-form"
      onClose={onClose}
      open
    >
      <DialogTitle header="Сведения о доверенности" title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="uspd-representative-form-content">
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">1</div>
            <div className="uspd-representative-form-box-title">Доверенность</div>
          </div>
          <Row className="row-cols-1 mt-3">
            <FieldDTOWithCol
              component={TextInputWithLabel}
              dtoObject={attributes.name_for_user}
              control={control}
              variant="material"
              inputClassName="custom-scroll-theme"
              withLabel
            />
          </Row>
          <Row className="row-cols-2 mt-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.created_at}
              variant="material"
              disabled
              withLabel
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              disabled
              changeFormat="YYYY-MM-DD"
              dtoObject={attributes.validity_period}
              variant="material"
              withLabel
            />
          </Row>
        </div>
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">2</div>
            <div className="uspd-representative-form-box-title">Сведения о представителе</div>
          </div>
          <FieldDTO
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.user_id}
            disabled
            usePortal
            portalClassName="executor-selector"
            loadAction={loadUserList}
            optionFormatter={item => ({ value: item.id, name: item.name })}
            filterName="full_name"
            variant="material"
            withLabel
          />
        </div>
        <div className="uspd-representative-form-box">
          <div className="uspd-representative-form-box-container">
            <div className="uspd-representative-form-box-number">3</div>
            <div className="uspd-representative-form-box-title">Сведения о доверителе</div>
          </div>
          <AutoAcceptApplicant control={control} disabled getValues={getValues} prefix="applicant." />
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button variant="secondary" onClick={onClose}>Отменить</Button>
          <Button onClick={() => handleRename(getValues())}>Принять</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
